
import React, { Fragment } from 'react'
import {AppRow,AppDate} from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row } from 'antd';

const apiData = [
    {attrName:'value',type:'string',defaultValue:'',remarks:'选项的value值'},
    {attrName:'onChange',type:'(value: Moment, text: string) => void',defaultValue:'',remarks:'选项该改变事件'},
    {attrName:'format',type:'string',defaultValue:'YYYY-MM-DD',remarks:'设置日期格式。配置参考 moment.js.格式为：YYYY-MM-DD HH:mm:ss，注意大小写。'},
    {attrName:'placeholder',type:'string',defaultValue:'',remarks:'placeholder'},
    {attrName:'readonly',type:'boolean',defaultValue:'false',remarks:'readonly'},
    {attrName:'size',type:'normal|small',defaultValue:'normal',remarks:''}
]

const options = [{label:'选项1',value:'选项1'},{label:'选项2',value:'选项2'}]
export const AppDateDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、时间输入框。<br/>
                2、引用：import {`{AppDate}`} from 'qcc'<br/>
                3、demo位置：src/demo/components/AppDateDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <Row style={{padding:20}}>
                    <AppRow>
                        <div style={{width:300}}>
                            <AppDate format='YYYY-MM-DD HH:mm:ss'  />
                        </div>
                    </AppRow>
                    <AppRow style={{marginTop:20}}>
                        <div style={{width:300}}>
                            <AppDate format='YYYY-MM-DD'  size="small" />
                        </div>
                    </AppRow>
                </Row>
            
                
            </div>
            
            <h1>API</h1>
             <DemoApiTable data={apiData}/>
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppDateDemo.tsx